export const TAB_CASHBACK = [0];
export const TAB_OFFER = [1,3,6];
export const TAB_FREE = [2,4,5];